import styled from 'styled-components/macro';

export const StyledClearButton = styled.button`
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  color: ${(props) => props.theme.colors.text.tertiary};
`;
